module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"meterManagement":"Zählerstände","dataEntry":"Datenerfassung","values":"Werte","ranking":"Ranking"},"en":{"meterManagement":"Meter management","dataEntry":"Data entry","values":"Values","ranking":"Ranking"}}')
  delete Component.options._Ctor
}
